<template>
  <div class="no-padding">
    <label v-if="editable" class="editable-header" @click="$emit('edit_clicked', 'header', 0)" v-html="header_html"></label>
    <label v-else class="question-label">{{ item.header || item.name }}</label>

    <QuestionCheckboxOptionRow
      v-for="(i, index) in item.options"
      :key="index"
      :row="i"
      :index="index"
      :editable="editable"
      @edit_clicked="option_edit_clicked"
      @selected="option_selected"
      @text_updated="text_updated"
    />


    <memlist-textarea
      v-if="show_text"
      id="text_unlocked"
      name="text_unlocked"
      title="Fritext"
      rows="4"
      layout="vertical"
      validation_type="TEXT"
      size="lg"

      v-model="input_text"

      placeholder="Fritext"
      :required="false"
    />
  </div>
</template>

<script>
import QuestionCheckboxOptionRow from './QuestionCheckboxOptionRow.vue';

export default {
  name: 'QuestionCheckboxOptions',
  props: ['item','editable'],
  emits: ['option_update','selected','edit_clicked'],
  components: {
    QuestionCheckboxOptionRow,
  },

  computed: {
    header_html() {
      return this.item.header || this.item.name;
    }
  },

  data() {
    return {
      selected: [], /// array of selected values
      show_text: false,
      input_text: null,
    };
  },

  watch: {
    item: {
      deep: true,
      handler() {
        this.selected = [];
      }
    },
    input_text: {
      deep: true,
      handler() {

        if (this.input_text) {
          this.$emit('selected', this.selected, this.input_text);
        }

      }
    },
    selected: {
      deep: true,
      handler() {
        
      }
    }
  },

  methods: {
    option_edit_clicked(part, index) {
      this.$emit('edit_clicked', 'question_text', index);
    },
    text_updated(option, value) {
      this.$emit('option_update', option, value);
    },
    option_selected(row, is_selected, input_text) {
      console.log('option_selected', row, is_selected, input_text);

      if (is_selected) {
        this.selected.push((row.text || row.name));
      }
      else {
        this.selected = this.selected.filter(i => i !== (row.text || row.name));
      }

      let unlock_text = false;

      for (const s of this.selected) {
        if (this.item.options.find(i => (i.text || i.name) === s).unlock_text) {
          unlock_text = true;
          break;
        }
      }
      this.show_text = unlock_text;

      //this.selected = option;

      this.$emit('selected', this.selected, this.input_text);
    },
    
  }
};
</script>


<style lang="scss" scoped>


.question-label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

/* Box wrapper */
.box {
  padding: 15px;
  padding-top: 20px;
  border: 1px solid #ececec;
  transition: border-color 0.3s, background-color 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.selected-box {
  border-color: #0085eb;
  background-color: #f6fdff;
}

.box-header {
  display: flex;
  align-items: center;
  width: 100%;
}

/* Checkbox styling from TableCheckbox */
.exp-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.exp-checkbox-label input {
  opacity: 0;
  width: 0;
  height: 0;
}

.exp-checkbox-custom {
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 2px solid #0085eb;
  border-radius: 4px;
  position: relative;
  transition: background-color 0.2s, border-color 0.2s;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom {
  background-color: #0085eb;
  border-color: #0085eb;
}

.exp-checkbox-custom::after {
  content: "";
  position: absolute;
  display: none;
}

.exp-checkbox-label input:checked ~ .exp-checkbox-custom::after {
  display: block;
}

.exp-checkbox-custom::after {
  left: 6px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.exp-checkbox-text {
  margin-left: 12px;
  font-size: 14px;
}

.editable-header {
  min-width: 300px;
  min-height: 20px;
  padding: 8px;
}
.editable-header:hover {
  border: 2px solid rgb(50, 201, 50);
}
</style>